export const ADD_DUPLICATED_BIDDING_NAME_MESSAGE = "One or more errors occurred. (Duplicated entity [Bidding] exception thrown";